export default __webpack_public_path__ + "media/images/compaigns/aug_18/accommodation-17c78429e62c9fb1b942cf6e8cd47f96.jpg";